"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasCapitalWords = exports.hasBadContent = exports.hasWebsite = exports.hasPhoneNumber = exports.hasBadWords = exports.hasEmail = exports.BadWordsList = void 0;
const emailRegex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i;
const phoneRegex = /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/g;
const simpleNumberRegex = /\d{2}\s\d{3}/g;
const capitalWords = /\b[A-Z]+\b/;
exports.BadWordsList = ['whatsapp'];
const hasEmail = (str = '') => !!str.match(emailRegex);
exports.hasEmail = hasEmail;
const hasBadWords = (str = '') => exports.BadWordsList.filter(word => str.toLocaleLowerCase().includes(word.toLocaleLowerCase())).length > 0;
exports.hasBadWords = hasBadWords;
const hasPhoneNumber = (str = '') => !!str.match(simpleNumberRegex) || !!str.match(phoneRegex);
exports.hasPhoneNumber = hasPhoneNumber;
const hasWebsite = (str = '') => str.indexOf('.com') > 0 || str.indexOf('www.') > 0;
exports.hasWebsite = hasWebsite;
const hasBadContent = (str = '') => (0, exports.hasBadWords)(str) || (0, exports.hasEmail)(str) || (0, exports.hasPhoneNumber)(str) || (0, exports.hasWebsite)(str);
exports.hasBadContent = hasBadContent;
const hasCapitalWords = (str = '') => capitalWords.test(str);
exports.hasCapitalWords = hasCapitalWords;
//# sourceMappingURL=restrictedContent.js.map